export default {
  iframeUrl: '',
  bankStatements: {},
  submissionStatus: null
}
